const actionsAccess=( controlerName,actionName)=>{
  
    const FindActionControle=(actions)=>{
        const actionName= actions?.map((item)=>item.actionName);
        const actionsSplit= actionName?.map((name)=>{
          const nameList= name.split(":",3);
          return nameList[2]
        }
        )
        return actionsSplit
       }
          const  actionsControle= actionControleHandler();
        const controlerActions= actionsControle?.[controlerName];
        const acessActionsList=FindActionControle(controlerActions);
       const controlerPermision= acessActionsList?.includes(actionName);
       return controlerPermision
    

   
}


const actionControleHandler = () => {
  const claims = JSON.parse(localStorage.getItem("claims"));



  
  let actionDetails = {};
  claims?.forEach((element, index) => {
    actionDetails[element.controllerName] = element.actionDetails;
  });
  return (actionDetails);
};
export{actionsAccess,actionControleHandler}

/**========================================================================
 * ?                                ABOUT
 * @author         :  JavadBoroji
 * @email          :  
 * @repo           :  
 * @createdOn      :  1403/02/22
 * @description    :  
 * this Function When use let's ask conditional render action Components.
 * compulsion action define in permisions
 * @Props           :
 * {
 *  actionsControle=All Actions that has in Clamis، when user login give and pass This Fn
 * controlerName=what controle Name used
 * actionName= actionName Related
 * }
 *========================================================================**/